export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/multgame/multgame-background-star-sky.svg'
